module.exports = __webpack_public_path__ + "media/images/animations/overhight_load/3-2c08d0d8b1b18f85219c5734b8b7468e.png";